import { render, staticRenderFns } from "./showRich.vue?vue&type=template&id=38618043&scoped=true"
import script from "./showRich.vue?vue&type=script&lang=js"
export * from "./showRich.vue?vue&type=script&lang=js"
import style0 from "./showRich.vue?vue&type=style&index=0&id=38618043&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38618043",
  null
  
)

export default component.exports